import { useEffect, type ReactNode } from 'react';
import { clsx } from '../../../ds/clsx';
import styles from './Phone.module.css';

export interface PhoneFrameProps {
  /** `navy` for Portal 02/09, `sand` for the others. */
  tone?: 'sand' | 'navy' | undefined;
  /** Document title of the page („Mandantenportal"). */
  title?: string | undefined;
  children: ReactNode;
}

/** Keeps public portal pages out of search engines (PLAN §7 „noindex") while they are mounted. */
export function useNoIndex(title: string): void {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      meta.remove();
      document.title = previousTitle;
    };
  }, [title]);
}

/**
 * The phone screen of Phase A (Mandantenportal 02, 08–13): full width below 768 px, a 420 px column on
 * `--sand-50` above (own). Children lay out top to bottom; a footer with `margin-top: auto` sits at the bottom.
 */
export function PhoneFrame({ tone = 'sand', title = 'Mandantenportal', children }: PhoneFrameProps) {
  useNoIndex(title);
  return (
    <div className={styles.page}>
      <main className={clsx(styles.screen, tone === 'navy' && styles.navy)}>{children}</main>
    </div>
  );
}
